// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { DateTimeUtils } from '@shared/utils/Time/DateTimeUtils';
import { EventCache } from '../cache/Event/EventCache';
import { EventType } from '../cache/Event/EventConstants';
import { Resources } from '@shared/localizations/Resources';
import { EventFormatter } from '../cache/Event/EventFormatter';
import { FilesHelper } from '@shared/utils/FilesHelper';
class _EventUtils {
    getEventTypeStr(eventType) {
        switch (eventType) {
            case EventType.None:
                return Resources.getResource('panel.EventLog.eventType.none');
            case EventType.Info:
                return Resources.getResource('panel.EventLog.eventType.info');
            case EventType.Exception:
                return Resources.getResource('panel.EventLog.eventType.exception');
            case EventType.Trading:
                return Resources.getResource('panel.EventLog.eventType.trading');
            case EventType.System:
                return Resources.getResource('panel.EventLog.eventType.system');
            case EventType.Comment:
                return Resources.getResource('panel.EventLog.eventType.comment');
            case EventType.Updater:
                return Resources.getResource('panel.EventLog.eventType.updater');
            case EventType.Alerts:
                return Resources.getResource('panel.EventLog.eventType.alerts');
            default:
                return null;
        }
    }
    saveLogFile() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const eventArr = yield EventCache.getEventsFromDB();
                const filename = `Logs_Package_${DateTimeUtils.formatDate(new Date(), 'DD_MM_YYYY_HH_mm_ss')}.log`;
                const source = EventFormatter.formattedData(eventArr);
                FilesHelper.saveFile(filename, source);
            }
            catch (error) {
                console.error('Error downloading event log file:', error);
            }
        });
    }
}
export const EventUtils = new _EventUtils();
